export default {
  headerContent: {
    title: 'Bereket Sigorta Kasko Sigortası Teklifi Hesaplama',
    slogan: "Araç Kasko Sigortası'nı işin uzmanına bırak.",
    btnTitle: 'ARAÇ KASKO SİGORTASI TEKLİFİ AL'
  },
  crossPageContent: {
    mainTitle: 'Bereket Sigorta Araç Kasko Sigortası',
    description: {
      title: 'Bereket Sigorta Araç Kasko Sigortası Nedir? ',
      content: [
        'Araç kasko sigortası, aracınızı işletim halindeyken veya atıl haldeyken karşılaşabileceği risklere karşı güvence altına almaktadır.',
        'Kasko sigortası, çarpma, çarpılma, devrilme, hırsızlık ve daha birçok hasar sonucunda büyük çaplı maddi kayıpları önlemektedir.',
        'Kasko sigortası, tipik olarak, aracınızın hasar görmesi durumunda ödeme yapan çarpışma ve kapsamlı sigortanın yanı sıra, bütçenizi de koruma altına alan sigorta ürünüdür.'
      ]
    },
    subContent: {
      title: 'Bereket Sigorta Araç Kasko Sigortası Teminatları Nelerdir?',
      content: [
        {
          paragraph:
            'Kasko teminatları seçmiş olduğunuz pakete göre farklılık göstermektedir.',
          subList: null
        },
        {
          paragraph: 'Kasko sigortası içerinde alabileceğiniz teminatlar;',
          subList: [
            'Çarpma veya çarpılma sonucu oluşan hasarlar,',
            'Hırsızlık teminatı,',
            'Yangın teminatı,',
            'Grev, lokavt, kargaşalık, halk hareketleri, kötü niyetli hareketler ve terörden dolayı oluşan hasarlar,',
            'Deprem teminatı,',
            'Sel veya su baskınları,',
            'Fırtına, dolu ve yıldırım düşmesi teminatlarından oluşmaktadır.'
          ]
        }
      ]
    }
  },
  getPrice: {
    mainTitle: 'Araç Sigortası Teklifi Nasıl Alınır?',
    campaigns: [
      {
        id: 1,
        name: 'Araç Kasko Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      },
      {
        id: 2,
        name: 'Araç Kasko Sigortası',
        assurance: 'Standart Teminatlı',
        price: '+50 TL'
      },
      {
        id: 3,
        name: 'Araç Kasko Sigortası',
        assurance: 'Zorunlu Teminatlı',
        price: '+50 TL'
      },
      {
        id: 4,
        name: 'Araç Kasko Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      }
    ]
  },
  faqTitle: 'Bereket Sigorta Araç Kasko Sigortası Hakkında Merak Edilenler',
  faqTitleDesc: 'Her gün yayınlanan güvenilir bilgilere kolay erişim.',
  questions: [
    {
      title: 'Bereket Sigorta Kasko Sigortası Teminat Dışı Haller Nelerdir?',
      content: [
        {
          paragraph: null,
          subList: [
            'Sürücü belgesi olmayan veya yetersiz olan kişilerin aracı kullanmasından dolayı oluşan hasarlar,',
            'Alkol veya uyuşturucu kullanımı sonrasında oluşan hasarlar,',
            'Aracın orijinalliğini bozacak şekilde sonradan yapılan eklemelerden kaynaklı hasarlar,',
            'Sigortalının kasti olarak oluşturacağı hasarlar teminatı dışı bırakılmıştır. '
          ]
        }
      ]
    },
    {
      title: 'Bereket Sigorta Kasko Sigortası İçin Gerekli Evraklar Nelerdir?',
      content: [
        {
          paragraph:
            'Gerekli evraklar aracın sıfır veya ikinci el olmasına göre değişmektedir.',
          subList: [
            'İkinci el ve yenileme dönemi yaklaşan araçlar için sadece ruhsat olması yeterlidir.',
            'Sıfır araçlarda proforma fatura araç sahibi T.C. Kimlik Numarası ve araç plaka il kodu gereklidir.'
          ]
        }
      ]
    },
    {
      title: 'Bereket Sigorta Araç Kasko Sigortası Çeşitleri Nelerdir?',
      content: [
        {
          paragraph:
            'Bereket Sigorta aracınızı güvence altına alabileceğiniz 3 adet kasko paketi bulunmaktadır.',
          subList: null
        },
        {
          paragraph: '<strong><em><u>Bu paketler;</u></em></strong>',
          subList: [
            'Dar kasko,',
            'Genişletilmiş Binek kasko,',
            'Bereket emektar kaskodan oluşmaktadır.'
          ]
        }
      ]
    },
    {
      title: 'Bereket Sigorta Dar Kasko Sigortası Nedir?',
      content: [
        {
          paragraph:
            'Dar kasko sigortası normal kasko sigortasına istinaden sadece aracın tam ziyaya uğradığı hasarları karşılamaktadır. Dar kasko sigortası kısmı hasarları karşılamamaktadır.',
          subList: null
        }
      ]
    },
    {
      title: 'Bereket Sigorta Dar Kasko Sigortası Teminatları Nedir?',
      content: [
        {
          paragraph: null,
          subList: [
            'Çarpma ve çarpışma,',
            'Hırsızlık,',
            'Devrilme,',
            'Yangın,',
            'Deprem,',
            'Fırtına, heyelan, dolu ve yıldırım,',
            'Sel ve su baskınları,',
            'Grev, lokavt ve terör olayları,',
            'Yetkili olmayan kişiler tarafından aracın çekilmesi sırasında uğrayacağı zararları kapsar.'
          ]
        }
      ]
    },
    {
      title: 'Bereket Sigorta Genişletilmiş Binek Kasko Sigortası Nedir?',
      content: [
        {
          paragraph:
            'Bu paket ile binek kullanım tarzında olan araç veya araçlarınızı ana ve ek teminatlarla güvence altına alabilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title:
        'Bereket Sigorta Genişletilmiş Binek Kasko Sigortası Teminatları Nedir?',
      content: [
        {
          paragraph:
            'Genişletilmiş binek kasko sigortası içerisinde ana ve ek teminatlar sunulmaktadır.',
          subList: null
        },
        {
          paragraph: '<strong><em><u>Ana teminatlar;</u></em></strong>',
          subList: [
            'Çarpma veya çarpılma sonucu oluşan hasarlar,',
            'Hırsızlık,',
            'Yangın teminatlarından oluşmaktadır.'
          ]
        },
        {
          paragraph: '<strong><em><u>Ek teminatlar;</u></em></strong>',
          subList: [
            'Asistans hizmeti,',
            'Cam değişimi,',
            'Deprem,',
            'İhtiyari mali mesuliyet,',
            'İkame araç hizmeti',
            'Kemirgen havyan zararları,',
            'LPG,',
            'Mini onarım hizmeti,',
            'Özel eşya,',
            'Sel ve su baskınları,',
            'Tedavi masrafları,',
            'Terör olayları,',
            'Yanlış akaryakıt dolumu teminatından oluşmaktadır.'
          ]
        }
      ]
    },
    {
      title: 'Bereket Sigorta Emektar Kasko Sigortası Nedir?',
      content: [
        {
          paragraph:
            'Emektar kasko ile 7 -18 yaş aralığında bulunan araçlarınızı risklere karşı Bereket Sigorta güvencesi altına alabilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title: 'Bereket Sigorta Dar Kasko Sigortası Teminatları Nedir?',
      content: [
        {
          paragraph: '<strong><em><u>Ana teminatları;</u></em></strong>',
          subList: [
            'Motorlu veya motorsuz araçlara çarpma veya çarpışma,',
            'Araç atıl halde iken alacağı hasarlar,',
            'Aracın yanması,',
            'Aracın veya araç parçalarının çalınması veya çalınmaya teşebbüs edilmesi,',
            'Fiil ehliyetine sahip olmayan kişilerin yapacağı hasarlar.'
          ]
        },
        {
          paragraph: '<strong><em><u>Ek Teminatları;</u></em></strong>',
          subList: [
            'Yanlış akaryakıt dolumu,',
            'Terör olayları,',
            'Tedavi masrafları,',
            'Sel ve su baskınları,',
            'Özel eşya,',
            'Mini onarım hizmeti,',
            'LPG,',
            'Kemirgen havyan zararları,',
            'İkame araç hizmeti',
            'İhtiyari mali mesuliyet,',
            'Deprem,',
            'Cam değişimi,',
            'Asistans hizmetlerinden oluşmaktadır.'
          ]
        }
      ]
    },
    {
      title: 'Bereket Sigorta Araç Kaskosu Coğrafi Sınır Nedir?',
      content: [
        {
          paragraph:
            'Aksine bir sözleşme bulunmaması durumunda kasko sigortanız sadece Türkiye sınırları içerisinde geçerlidir.',
          subList: null
        }
      ]
    },
    {
      title: 'Bereket Sigorta Araç Kaskosu Geçerlilik Süresi Nedir?',
      content: [
        {
          paragraph:
            'Kasko sigortası geçerliliği, poliçede yazan başlangıç tarihinden itibaren 1 yıldır. Poliçe başlangıç ve bitiş tarihleri poliçe üzerinde yazmaktadır. Eğer poliçenizi kaybettiyseniz e devlet üzerinden poliçenizi görüntüleyebilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title: 'Bereket Sigorta Kasko Hasarsızlık İndirimi Ne Kadar Geçerli?',
      content: [
        {
          paragraph:
            'Bereket Sigorta ile kazanmış olduğunuz hasarsızlık indirimi 1 yıla kadar korunmaktadır.',
          subList: null
        }
      ]
    },
    {
      title: 'Bereket Sigorta Araç Kasko Meslek İndirimi Nedir?',
      content: [
        {
          paragraph:
            'Kasko sigortasında bulunan meslek indirimleri önceden belirlenmiş olan meslek gruplarına ekstra indirim sunmaktadır. ',
          subList: null
        },
        {
          paragraph:
            'Belirli meslek gruplarına verilen bu indirimlerden yararlanmak için teklif alma aşamasında mesleğinizi belirtmeniz gerekmektedir. Meslek indirimi almış müşteriler hasar durumunda tabi olduğu mesleği belgelemek zorundadır. Mesleğin belgelendirilmemesi durumunda hasar ödemesinde muafiyet uygulanabilir.',
          subList: null
        }
      ]
    },
    {
      title: 'Bereket Sigorta Kasko Cam Değişimi Teminatı Nedir?',
      content: [
        {
          paragraph:
            'Cam değişimi teminatı kasko sigortası vadesi içerinde alacağınız cam hasarlarını kasko poliçenizi bozmadan yaptırmanıza olanak sağlayan teminattır.',
          subList: null
        },
        {
          paragraph:
            'Bu teminat kapsamında yılda bir defaya mahsus olmak şartıyla ön veya arka camı ücretsiz olarak değiştirebilirsiniz. Cam hasarının tekrarlanması durumunda kasko poliçenizden yaptırabilirsiniz. Yalnız hasarsızlığınız etkilenmektedir.',
          subList: null
        }
      ]
    },
    {
      title: 'Bereket Sigorta Kasko Mini Onarım Teminatı Nedir?',
      content: [
        {
          paragraph:
            'Mini onarım teminatı aracınızda oluşan küçük çapı hasarları kasko sigortanızı bozmadan yaptırmanıza olanak sağlamaktadır. ',
          subList: null
        },
        {
          paragraph:
            'Mini onarım hizmetini sadece sigorta şirketinin anlaşmalı olduğu servislerde alabilirsiniz. Anlaşmasız yerde yapılan mini onarımlar poliçe kapsamına alınmayabilir veya poliçede yazan muafiyet oranı uygulanabilir.',
          subList: null
        }
      ]
    },
    {
      title: 'Bereket Sigorta Kasko Mini Onarım Neleri Kapsar?',
      content: [
        {
          paragraph: 'Mini onarım teminatı;',
          subList: [
            'Boya tamiri,',
            'Cam ve plastik hasarları,',
            'İç döşeme tamiri,',
            'Küçük çaplı göçükler,',
            'Küçük çiziklerin tamirini kapsamaktadır.'
          ]
        }
      ]
    },
    {
      title: 'Park Halindeki Aracım Hasar Almış Kasko Sigortam Karşılar Mı?',
      content: [
        {
          paragraph:
            'Aracınız park halinde iken oluşan hasarlar sigorta poliçeniz kapsamındadır. Oluşan hasarı beyan etmeniz durumunda kasko sigortanızdan karşılayabilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title: 'LPG’li Araca Kasko Yapılır Mı?',
      content: [
        {
          paragraph:
            'LPG’li araca kasko sigortası yapılmaktadır. Yalnız kasko sigortası tanzim edilirken LPG aksesuar olarak eklenmesi gerekmektedir.',
          subList: null
        }
      ]
    },
    {
      title:
        'Aracımda Bulunan LPG’den Kaynaklı Hasarları Kasko Sigortam Karşılar Mı?',
      content: [
        {
          paragraph:
            'Aracın içerisinde bulunan LPG’den kaynaklı olan hasarlar poliçenize LPG teminatı ekletmeniz durumunda poliçe kapsamına alınmaktadır.',
          subList: null
        }
      ]
    },
    {
      title:
        'Kasko Sigortam Yok, Trafik Sigortası Aracımda Oluşan Hasarı Karşılar Mı?',
      content: [
        {
          paragraph:
            'Trafik sigortası trafikte karşı tarafa veya 3. Kişilere verilen hasarı karşılamaktadır. Bu bağlamda trafik sigortası sizin aracınızda oluşan hasarı karşılamamaktadır.',
          subList: null
        }
      ]
    },
    {
      title:
        'Bereket Sigorta Aracım Çalınması Halinde Tazminat Ödemesinde Bekleme Süresi Bulunuyor Mu?',
      content: [
        {
          paragraph:
            'Kasko sigortası genel şartları gereğince hasar ihbarından itibaren 30 günlük bekleme süresi bulunmaktadır. Bu süre sonucunda hasarın onaylanması durumunda 15 gün içerisinde ödeme yapılmaktadır.',
          subList: null
        }
      ]
    },
    {
      title:
        'Aracıma Eklettiğim Aksesuarlarda Oluşan Hasarları Kaskom Karşılar Mı?',
      content: [
        {
          paragraph:
            'Aracınıza eklettiğiniz tüm aksesuarları sigortanıza bedelleri ile birlikte ekletmeniz gerekmektedir. Ekletmediğiniz tüm aksesuar hasarları kasko kapsamına karşılanmaz.',
          subList: null
        }
      ]
    },
    {
      title:
        'Cep telefonum Aracımın İçinden Çalındı Kasko Sigortam Karşılar Mı?',
      content: [
        {
          paragraph:
            'Kasko sigortası genel şartları gereğince telefon kişisel eşya kapsamına alınmamaktadır. Bu nedenle araç içinden çalınan telefonunuz kasko sigortasından karşılanmamaktadır.',
          subList: null
        }
      ]
    },
    {
      title: 'Bereket Sigorta Tahmini Kasko Fiyatları Neye Göre Hesaplanır?',
      content: [
        {
          paragraph:
            'Kasko sigortası fiyatları, araç bilgileri, sigortalı bilgileri, geçmiş dönem hasarsızlık bilgileri ve teminatlara göre hesaplanmaktadır. ',
          subList: null
        }
      ]
    },
    {
      title: 'Bereket Sigorta Kasko Sigortasın Kaç Taksit Yapılıyor?',
      content: [
        {
          paragraph:
            'Bereket Sigorta’dan kasko sigortalarınızı kredi kartınızla peşin alabileceğiniz gibi 12 ay vadeli olarak alabilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title: 'Bereket Sigorta Tahmini Kasko Fiyatları Neye Göre Hesaplanır?',
      content: [
        {
          paragraph:
            'Kasko fiyatları araç bedeli, araçta bulunan harici aksesuar bedeli, sigortalı hasar geçmişi ve sigortalının ihtiyaçları doğrultusunda seçeceği teminatlara göre hesaplanmaktadır.',
          subList: null
        }
      ]
    },
    {
      title: 'Bereket Sigorta Online Kasko Teklifi Nasıl Alınır?',
      content: [
        {
          paragraph: 'Online kasko sigortası almak alokasko ile artık çok daha kolay.',
          subList: null
        },
        {
          paragraph: 'Sizin için en uygun kasko sigortası için alokasko.com üzerinden başvuru formu doldurabilir veya 0216 371 67 77 numaralı hattan uzman danışmanlarımızla iletişime geçebilirsiniz.',
          subList: null
        },
        {
          paragraph: 'Bu işlemler sonucu Alokasko uzman ekibi sizin için en uygun teklifi hazırlayıp sunacaktır.',
          subList: null
        }
      ]
    }
  ]
}
